/**
 * Format a date/time string for display
 * Shows time only for today's dates, full date and time for other dates
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDateTime = (date) => {
  if (!date) return 'N/A';

  const today = new Date();
  const messageDate = new Date(date);

  // Check if the message is from today
  const isToday = messageDate.toDateString() === today.toDateString();

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  if (isToday) {
    return formatTime(messageDate);
  } else {
    // Show date and time for messages not from today in yyyy/mm/dd format
    const year = messageDate.getFullYear();
    const month = String(messageDate.getMonth() + 1).padStart(2, '0');
    const day = String(messageDate.getDate()).padStart(2, '0');
    const time = formatTime(messageDate);
    return `${year}/${month}/${day} ${time}`;
  }
};

/**
 * Format a date for display (date only)
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return 'N/A';

  const messageDate = new Date(date);
  const year = messageDate.getFullYear();
  const month = String(messageDate.getMonth() + 1).padStart(2, '0');
  const day = String(messageDate.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
};

/**
 * Format a time for display (time only)
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted time string
 */
export const formatTime = (date) => {
  if (!date) return 'N/A';

  const messageDate = new Date(date);
  return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/**
 * Format a date for HTML input type="date" (YYYY-MM-DD)
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string for input
 */
export const formatDateForInput = (date) => {
  if (!date) return '';

  const messageDate = new Date(date);
  const year = messageDate.getFullYear();
  const month = String(messageDate.getMonth() + 1).padStart(2, '0');
  const day = String(messageDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * Get today's date in YYYY-MM-DD format
 * @returns {string} Today's date
 */
export const getTodayDate = () => {
  const today = new Date();
  return formatDateForInput(today);
};

/**
 * Get a date range (e.g., last 7 days, last 30 days)
 * @param {number} days - Number of days to go back
 * @returns {object} Object with startDate and endDate
 */
export const getDateRange = (days) => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);

  return {
    startDate: formatDateForInput(startDate),
    endDate: formatDateForInput(endDate)
  };
};
